export const GET_ORGANIZATIONS_OVERVIEW_START =
  'GET_ORGANIZATIONS_OVERVIEW_START';
export const GET_ORGANIZATIONS_OVERVIEW_SUCCESS =
  'GET_ORGANIZATIONS_OVERVIEW_SUCCESS';
export const GET_ORGANIZATIONS_OVERVIEW_ERROR =
  'GET_ORGANIZATIONS_OVERVIEW_ERROR';
